var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticStyle:{"margin-top":"20px","width":"100%","display":"flex","justify-content":"center","height":"100px"}},[_c('b-spinner')],1):_vm._e(),_c('div',{ref:"dropinTarget"})])}
var staticRenderFns = []

export { render, staticRenderFns }